const youtubeData = [
  {
    id: "f77IhyXX5D8",
    title: "Como criar uma VPS de graça utilizando AWS EC2",
    date: "15/02/2023",
    views: "8.3K"
  },
  {
    id: "m7mNbRpHUdM", 
    title: "Como criar um Chatbot/API WhatsApp de graça",
    date: "04/11/2022",
    views: "4.9K"
  },
  {
    id: "dP2Hv6Qv_lU",
    title: "Minha Saudade – uma inteligência artificial feita para sentir",
    date: "20/07/2025",
    views: "24"
  },
  {
    id: "hil7qL6L-XI",
    title: "Como criar um servidor de GTA SAMP de graça",
    date: "23/04/2022", 
    views: "153"
  },
  {
    id: "Xqp9bGeINtM",
    title: "Criei um servidor de FIVEM RP/ROLEPLAY ",
    date: "11/11/2024",
    views: "92"
  },
  {
    id: "bvNSTWmPX6A",
    title: "Como criar um banco digital de graça",
    date: "30/07/2024",
    views: "150"
  }
];

export default youtubeData;